<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerut0a-ch0301" class="chapter" epub:type="division" id="ut0a-ch03">
<header id="headerut0a-ch0301">
<h1 class="cn"><span aria-label="22" class="page" id="p22" role="doc-pagebreak"></span><a class="xref" href="#/chilashvol20005#toc">3</a></h1>
<h1 class="ct">US House, Thaddeus Stevens, Proposed Amendments</h1>
<h1 class="cs" role="doc-subtitle">December 5, 1865<a class="fnref" href="#/chilashvol20268#fn4" id="fn4r" role="doc-noteref">4*</a></h1>
</header>
<section>
<h2 class="ahaft" id="ahaft0601">Rebel Debt.</h2>
<p class="pf">Mr. STEVENS introduced the following joint resolution; which was read a first and second time, and ordered to be referred to the Committee on the Judiciary, when the same shall have been appointed:</p>
<blockquote>
<p class="bqf"><i>Resolved by the Senate and House of Representatives of the United States in Congress assembled</i>, That the following amendment to the Constitution of the United States shall be proposed, and when ratified by the Legislatures of three fourths of the States shall be valid to all intents and purposes as part of the Constitution of the United States:</p>
<p class="bql">Neither the United States nor any State in the Union shall ever assume or pay any part of the debt of the so-called confederate States of America, or of any State, contracted to carry on war with the United States.</p>
</blockquote>
<p>. . .</p>
</section>
<section>
<h2 class="ah" id="ah0601">Apportionment of Representation.</h2>
<p class="paft">Mr. STEVENS also introduced the following joint resolution; which was read a first and second time, and ordered to be referred to the Committee on the Judiciary, when the same shall have been appointed:</p>
<blockquote>
<p class="bqf"><i>Resolved by the House of Representatives</i>, (the Senate concurring,) That the following amendment to the Constitution of the United States shall be proposed to the several States, and when ratified by the Legislatures of three fourths of the States shall be valid to all intents and purposes as part of the Constitution of the United States:</p>
<p class="bq">Representatives shall be apportioned among the States which may be within the Union according to their respective legal voters; and for this purpose none shall be named as legal voters who are not either natural-born citizens or naturalized foreigners.<span class="page" data-locator="p22"></span> Congress shall provide for ascertaining the number of said voters. A true census of the legal voters shall be taken at the same time with the regular census.</p>
</blockquote>
</section>
<section>
<h2 class="ah" id="ah0602">Equality before the Law.</h2>
<p class="paft">Mr. STEVENS also introduced the following joint resolution; which was read a first and second time, and ordered to be referred to the Committee on the Judiciary, when the same shall have been appointed:</p>
<blockquote>
<p class="bqf"><i>Resolved by the Senate and House of Representatives in Congress assembled</i>, That the following amendment to the Constitution of the United States shall be proposed, and when ratified by the Legislatures of three fourths of the States shall be valid to all intents and purposes as part of the Constitution of the United States:</p>
<p class="bq">A<span class="sm">RTICLE</span> XIII. All national and State laws shall be equally applicable to every citizen, and no discrimination shall be made on account of race and color.</p>
</blockquote>
</section>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lash-vol2-0013.vue?50228685